<template>
  <div>
    <div v-if="showBlock === 'copy'">
      <h1
        v-if="offer"
        class="mb-0"
      >
        {{ offer.titleTitle }}
      </h1>
      <div style="font-size: 1.2rem">
        ({{ offer.locationProvince }})
      </div>
      <hr>
      <h2>{{ $t('pages.copy-offer.title') }}</h2>

      <!-- PROMO Code -->
      <h4 class="text-left">
        {{ $t('pages.copy-offer.subtitle') }}
      </h4>

      <!-- eslint-disable -->
      <b-alert
        :show="discount > 0"
        variant="success"
        v-html="$t('pages.copy-offer.promo-applied', { discount: discount })"
      />
      <!-- eslint-enable -->
      <div class="row mb-3">
        <div class="col-8">
          <b-form-input
            v-model="code"
            :placeholder="$t('pages.copy-offer.promo-placeholder')"
            :state="isCodeValid"
            style="text-transform: uppercase;"
          />
          <b-form-invalid-feedback id="input-live-feedback">
            {{ $t('pages.copy-offer.promo-invalid') }}
          </b-form-invalid-feedback>
        </div>
        <div class="col-4 text-left">
          <b-button
            variant="info"
            size="sm"
            @click="checkPromo"
          >
            {{ $t('pages.copy-offer.promo-apply') }}
          </b-button>
        </div>
        <div class="obtain-promo">
          {{ $t('pages.copy-offer.obtain-promo') }}
        </div>
      </div>

      <!-- Select provincias -->
      <b-form-select
        v-model="provincesSelected"
        class="multi-select"
        :options="provinceOptions"
        multiple
        :select-size="10"
      />
      <div class="text-left mt-3">
        <b-button
          size="sm"
          variant="info"
          @click="showWarningModal"
        >
          {{ $t('pages.copy-offer.add') }}
        </b-button>
      </div>
      <b-modal
        id="confirm-save"
        :title="$t('generic.warning', 'Warning')"
        centered
        header-bg-variant="warning"
        :ok-title="$t('generic.accept', 'Accept')"
        :cancel-title="$t('generic.cancel', 'Cancel')"
        @ok="saveDuplicates"
      >
        {{ $t('pages.copy-offer.dialog-title', { number: provincesSelected.length}) }}

        <!-- eslint-disable -->
        <div
          style="font-size: 0.8rem"
          v-html="$t('pages.copy-offer.dialog-warning', { provincesSelected: provincesSelected.length })"
        />
        <!-- eslint-enable -->
      </b-modal>
    </div>
    <div v-if="showBlock === 'success'">
      <b-alert
        show
        variant="success"
        class="p-4"
      >
        {{ $t('pages.copy-offer.save-sucess', {savedCount: savedCount}) }}
        <div class="mt-2">
          <b-button
            size="sm"
            variant="info"
            @click="$router.push({ name: 'my-offers' })"
          >
            {{ $t('pages.copy-offer.view-offers') }}
          </b-button>
        </div>
      </b-alert>
    </div>
  </div>
</template>

<script>
import provinces from "@/assets/data/provinces";
export default {
  data() {
    return {
      showBlock: "copy",
      savedCount: 0,
      offer: null,
      provincesSelected: [],
      isCodeValid: null,
      discount: null,
      code: null
    }
  },
  computed: {
    provinceOptions: () => provinces(),
  },
  async mounted() {
    if(this.$route.params.id) {
      await this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      this.axios
        .get('/offer/one/' + this.$route.params.id)
        .then( response => {
          this.offer = response.data;
        })
        .catch()
    },
    showWarningModal() {
      // Check for PROMO CODE!
      if(!this.isCodeValid) {
        this.$toastNotification('danger', '', this.$t('pages.copy-offer.alert.must-enter-valid-promo', 'Must enter a valid promo code!'));
        return;

      } else if(this.provincesSelected.length > this.discount) {
        this.$toastNotification('danger', '',
            this.$t(
              'pages.copy-offer.alert.can-only-copy-to',
              'You can only make a copy to {count} provinces with this promo code',
              {count: this.discount})
        );
        return;
      }
      this.$bvModal.show('confirm-save');
    },
    saveDuplicates() {
      this.offer.offerType = 'duplicate';
      let data = {
        offer: this.offer,
        provincesSelected: this.provincesSelected,
        promoCode: this.code
      };
      this.axios.post('/offer/multiple', data)
        .then( response => {
          this.showBlock = "success";
          this.savedCount = response.data;
        })
        .catch();
    },
    checkPromo() {
      this.axios.post('/payment/check-promo', { code: this.code, type: "multiprovincia" })
        .then( response => {
          this.isCodeValid = true;
          this.discount = response.data.discount;
        })
        .catch( () => {
          this.code = "";
          this.discount = null;
          this.isCodeValid = false;
          this.$toastNotification('danger', '', this.$t('pages.copy-offer.promo-invalid', 'Promo code is invalid!'));
        })
    }
  }
}
</script>

<style lang="scss">
.multi-select {
  option {
    padding: 3px;
  }
}

.obtain-promo {
  text-align: left;
  font-size: 0.85rem;
  color: #8e2d2d;
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
